<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="overflow-auto">
          <ts-loading-banner :loading="student_search">
            <div id="student-list">
              <table class="table table-hover ui-table ts-table">
                <thead>
                  <tr>
                    <th>{{ $t('preInvoice.cardNumber') }}</th>
                    <th>{{ $t('preInvoice.studentName') }}</th>
                    <th style="width:7%">{{ $t('preInvoice.sex') }}</th>
                    <th>{{ $t('preInvoice.academicTermName') }}</th>
                    <th>{{ $t('preInvoice.gradeName') }}</th>
                    <th>{{ $t('preInvoice.status') }}</th>
                  </tr>
                  <tr>
                    <th colspan="6">
                      <input
                        v-model.trim="searchValue"
                        type="text"
                        class="form-control"
                        :class="{ loading: student_search }"
                        :placeholder="$t('preInvoice.searchStudent')"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(student, index) in studentResource"
                    :key="index"
                    @dblclick="selectStudent(student, index)"
                  >
                    <td
                      class="ts-whitespace-no-wrap"
                      :class="{ 'selected-class': index == selectedIndex }"
                    >
                      {{ student.student_profile.card_number }}
                    </td>
                    <td
                      class="ts-whitespace-no-wrap"
                      :class="{ 'selected-class': index == selectedIndex }"
                    >
                      {{ student.student_profile.full_name_en }}
                    </td>
                    <td
                      class="ts-whitespace-no-wrap"
                      :class="{ 'selected-class': index == selectedIndex }"
                    >
                      {{ student.student_profile.gender }}
                    </td>
                    <td
                      class="ts-whitespace-no-wrap"
                      :class="{ 'selected-class': index == selectedIndex }"
                    >
                      {{ student.academic_class.academic_term.term_name }}
                    </td>
                    <td
                      class="ts-whitespace-no-wrap"
                      :class="{ 'selected-class': index == selectedIndex }"
                    >
                      {{
                        student.academic_class.grade
                          ? student.academic_class.grade.grade_name_foreign
                          : null
                      }}
                    </td>
                    <td
                      class="ts-whitespace-no-wrap"
                      :class="{ 'selected-class': index == selectedIndex }"
                    >
                      <span
                        class="badge badge-primary"
                        v-if="student.academic_class.ac_status_id == 1"
                        >{{ $t('preinvoice.current') }}</span
                      >
                      <span v-else class="badge badge-info">{{
                        $t('next')
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="validate" v-if="errors.has('student_id')">
                {{ errors.first('student_id') }}
              </div>
            </div>
          </ts-loading-banner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'preInvoiceStudentList',
  props: ['value', 'validate'],
  data() {
    return {
      model: {},
      student_search: false,
      searchValue: '',
      studentResource: [],
      errors: new Errors(),
      selectedIndex: null
    }
  },
  computed: {
    is_external() {
      return this.$store.state.authUser.is_external
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    ...mapActions('preInvoice', ['getStudent']),
    selectStudent(student, index) {
      this.selectedIndex = index
      this.model.student_id = student.student_id
      this.model.ac_year_id = student.academic_class.ac_year_id
      this.model.acp_id = student.academic_class.acp_id
      this.model.acps_id = student.academic_class.acps_id
      this.model.study_time =
        student.academic_class.academic_study_time.study_time
      this.$store.commit(
        'preInvoice/SET_ROOM_TYPE_ID',
        student.academic_class.room
          ? student.academic_class.room
            ? student.academic_class.room.room_type_id
            : null
          : null
      )
      this.$emit('student-info', student)
    },
    searchStudent(params) {
      this.student_search = true
      this.studentResource = []
      this.getStudent(params)
        .then(response => {
          this.studentResource = _.uniqWith(response.data, _.isEqual)
        })
        .finally(() => {
          this.student_search = false
        })
    }
  },
  watch: {
    searchValue: debounce(function(value) {
      if (value) {
        this.searchStudent({
          search: value,
          filter: {
            ac_status_id: '1,3'
          },
          page: -1
        })
      }
    }, 500),
    validate: function(error) {
      this.errors = new Errors(error.errors)
    },
    is_external: debounce(function() {
      this.searchStudent({
        search: this.searchValue,
        filter: {
          ac_status_id: '1,3'
        },
        page: -1
      })
    }, 500)
  }
}
</script>

<style lang="css" scoped>
#student-list {
  max-height: 31vh;
  height: 30vh;
  overflow: scroll;
}
table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
  padding: 7px;
  border-bottom: none !important;
}
table > tbody > tr > td {
  cursor: pointer;
}
.selected-class {
  border-bottom: 1px solid #69bafb;
  border-top: 1px solid #69bafb;
  background: #1d68b3;
  color: white;
  font-weight: 700;
}
.loading {
  background-color: #ffffff;
  background-image: url('http://loadinggif.com/images/image-selection/3.gif');
  background-size: 18px 18px;
  background-position-x: 99%;
  background-position-y: 50%;
  background-repeat: no-repeat;
}
</style>
